import { useEffect, useState } from 'react'
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Buttons from './Buttons';

const ToggleButtons = ({ props }) => {
  const alignment = props.alignment
  const handleAlignment = props.handleAlignment
  const title = props.title

  const styleButtons = (position, select) => {
    return{
      width: 'max-content',
      color: '#FFFFFF',
      backgroundColor: position === select ? '#E7662B' : select > position ? '#2E2C2B' : '#CBCACA',
      marginRight: '10px',
      '&:focus': {
        backgroundColor: '#E7662B'
      }
    }
  }

  const style = {
    width: '33%', 
    border: 'none', 
    backgroundColor: '#ffffff',
    display: 'flex',
    justifyContent: 'flex-start',
    padding: '0 0 0 0px',
    '&.Mui-selected': {
      backgroundColor: '#fff',
      width: '95%'
    },
  }

  return (
    <ToggleButtonGroup
      value={alignment}
      exclusive
      onChange={handleAlignment}
      aria-label="text alignment"
      sx={{
        width: '100%',
      }}
    >
      <ToggleButton sx={style} value={1}>
        <Buttons text={'01'} sx={styleButtons(1, alignment)} />
        {alignment === 1 && title.titleOne}
      </ToggleButton>
      <ToggleButton sx={style} value={2} aria-label="right aligned">
        <Buttons text={'02'} sx={styleButtons(2, alignment)} />
        {alignment === 2 && title.titleTwo}
      </ToggleButton>
    </ToggleButtonGroup>
  );
}

export default ToggleButtons
